import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles, Zap, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MakeoverTool from "@/components/MakeoverTool";

const PERKS = [
  { icon: ShieldCheck, text: "No password or website access required" },
  { icon: Zap, text: "A modern homepage concept in a few minutes" },
  { icon: Sparkles, text: "Full report by email or WhatsApp — your choice" },
];

export default function WebsiteMakeover() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-slate-50" data-testid="makeover-page">
        <section className="bg-gradient-to-b from-blue-50 to-white text-slate-900 pt-32 pb-16 md:pt-40 md:pb-24 border-b border-blue-100/70">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-2 mb-4">
              <Sparkles size={16} className="text-blue-700" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Free Website Makeover Preview</span>
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold max-w-3xl leading-[1.05]">
              See how your website could look
            </h1>
            <p className="text-slate-600 text-base md:text-lg mt-5 max-w-2xl">
              Enter your website address and our AI Website Designer will create a modern homepage concept from your public site. Preview it instantly — then get the full PDF report sent to you.
            </p>

            <div className="mt-8">
              <MakeoverTool standalone />
            </div>
            <p className="text-slate-500 text-xs mt-3">
              Free concept preview • No credit card • No website credentials • Usually ready in a few minutes
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              {PERKS.map((p, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 + i * 0.08 }}
                  className="flex items-center gap-2.5 text-sm text-slate-600">
                  <p.icon size={17} className="text-blue-600 shrink-0" /> {p.text}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-center">
          <p className="text-slate-500">Want to see concepts we've created for other businesses?</p>
          <Link to="/gallery" data-testid="makeover-gallery-link" className="inline-flex items-center gap-2 text-brand font-semibold mt-2">
            Browse the AI Rebuild Gallery <ArrowRight size={16} />
          </Link>
        </section>
      </main>
      <Footer />
    </>
  );
}
